// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1FuNa","fileBtn":"File_fileBtn__1sinp","closeBtn":"File_closeBtn__2J3_R","fileSelected":"File_fileSelected__19yJd","disabled":"File_disabled__3Xqf6"};